var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"state-box",class:[_vm.state ==='enabled'? 'enabledColor':'',_vm.state ==='paused'? 'pausedColor':'',_vm.state==='archived'? 'archivedColor':''],staticStyle:{"flex-shrink":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }